import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCardLayoutLarge12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCardLayoutLarge12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 2H1.5a.5.5 0 0 0-.5.5V7h2zm1 3v2h3V5zm0-1h3V2H4zm4 1v2h3V5zm3-1H8V2h2.5a.5.5 0 0 1 .5.5zm1 0v5.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5v-7A1.5 1.5 0 0 1 1.5 1h9A1.5 1.5 0 0 1 12 2.5zM7 8h4v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCardLayoutLarge12);
